export const selectAgencies = (state) => state?.opportunity?.agencies?.data;

export const selectAgenciesLoading = (state) =>
  state?.opportunity?.agencies?.agenciesLoading;

export const selectAgenciesLoaded = (state) =>
  state?.opportunity?.agencies?.agenciesLoaded;
